export const OWN_STAY_INGREDIENT_SUFFIX = 'ow';
export const PROPS_PREFIX = 'props:';
